export interface Filters {
	filetype? :number[];
	status?: number[];
	channel?: number;
	uid?: number;
	groupid?: number;
	moderationStatus?: string;
	moderationstatus?: string;
	query?: string;
	extension?: string;
	contenttype?: string ;
	startTime?: string; 
	endTime?: string; 
}     

export const defaultFilters: Filters = {
	filetype:[0,1,2,3,4], 
	status:[1,2,3,4],
	startTime:'90 Days ago', 
	endTime:'Now', 
	query:'',
	extension:'',
	channel:0,
	moderationStatus:"0"

}
